var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ScrollView, vevet } from '@anton.bobrov/vevet-init';
import { isUndefined, useDeepCompareMemoize } from '@anton.bobrov/react-hooks';
import { ScrollViewContext } from './utils/context';
/**
 * ScrollView provider.
 * ScrollView lets you detect visible elements in viewport
 */
export var Provider = function (_a) {
    var children = _a.children, instanceKey = _a.instanceKey, intersectionRoot = _a.intersectionRoot, states = _a.states, hasDelay = _a.hasDelay, maxDelay = _a.maxDelay, direction = _a.direction, viewportTarget = _a.viewportTarget, resizeDebounce = _a.resizeDebounce, _b = _a.isEnabled, isEnabled = _b === void 0 ? false : _b, props = __rest(_a, ["children", "instanceKey", "intersectionRoot", "states", "hasDelay", "maxDelay", "direction", "viewportTarget", "resizeDebounce", "isEnabled"]);
    var _c = useState(), scrollView = _c[0], setScrollView = _c[1];
    var vevetRef = useRef(vevet);
    var changeableProps = __assign(__assign({}, props), { isEnabled: isEnabled });
    var initialChangeablePropsRef = useRef(changeableProps);
    useEffect(function () {
        if (!vevetRef.current || isUndefined(instanceKey)) {
            return undefined;
        }
        var instance = new ScrollView(__assign(__assign({}, initialChangeablePropsRef.current), { intersectionRoot: intersectionRoot, states: states, hasDelay: hasDelay, maxDelay: maxDelay, direction: direction, viewportTarget: viewportTarget, resizeDebounce: resizeDebounce }));
        setScrollView(instance);
        return function () {
            setScrollView(undefined);
            instance.destroy();
        };
    }, [
        instanceKey,
        direction,
        hasDelay,
        intersectionRoot,
        maxDelay,
        resizeDebounce,
        states,
        viewportTarget,
    ]);
    var contextValue = useMemo(function () { return ({ scrollView: scrollView }); }, [scrollView]);
    useEffect(function () {
        if (!scrollView) {
            return;
        }
        scrollView.changeProps(changeableProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollView, useDeepCompareMemoize(changeableProps)]);
    return (React.createElement(ScrollViewContext.Provider, { value: contextValue }, children));
};
//# sourceMappingURL=Provider.js.map